import React from "react";
import NavBar from "../MyComponents/NavBar";
import "../MyComponents/reports.css";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";

export default function VistaarDashboard() {
  const initialToken = localStorage.getItem("token");
  const history = useHistory();

  useEffect(() => {
    if (!initialToken) {
      history.push("/login");
    }
  }, [initialToken, history]);
  return (
    <>
      <NavBar detailView={true} />
      <div>
        <iframe
          title="Vistaar"
          width="600"
          height="373.5"
          src="https://app.powerbi.com/view?r=eyJrIjoiOGNmNjE0ZmItMzM5Ni00ZTUwLWI0MTctY2M0NjUxY2U4Y2JjIiwidCI6ImIyYTViZGZhLTU0MzktNGUxMy04YTBlLWRmODIwMTJiMTQ2YSIsImMiOjZ9"
          frameborder="0"
          allowFullScreen="true"
          id="reports"
        ></iframe>
      </div>
    </>
  );
}
